import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { siteWide } from '@helpers/grid';
import styled from 'styled-components';
const Container = styled.nav `
  padding: 16px 0;
  background-color: transparent;
  overflow: hidden;
  z-index: 2;

  &[data-theme='light'] {
    --textColor: ${brand.black};
  }

  &[data-theme='mid'],
  &[data-theme='dark'] {
    --textColor: ${brand.white};
  }

  color: var(--textColor);
`;
const BreadcrumbList = styled.ol `
  ${siteWide};
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0;

  @media (hover: none) {
    flex-wrap: nowrap;
    white-space: nowrap;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;
const Breadcrumb = styled.li `
  font-size: 12px;
  line-height: 26px;
  letter-spacing: -0.01em;
  ${fonts.helvetica.bold};
  color: currentColor;
`;
const BreadcrumbLink = styled.a `
  color: currentColor;
  text-decoration: none;
  ${fonts.helvetica.regular};
  font-weight: 400;

  &:hover {
    text-decoration: underline;
  }
`;
const BreadcrumbDivider = styled.span `
  &[data-theme='light'] {
    --dividerColor: ${brand.blue.blue9};
  }

  &[data-theme='mid'],
  &[data-theme='dark'] {
    --dividerColor: ${brand.white};
  }

  color: var(--dividerColor);
  ${fonts.helvetica.regular};
  font-weight: 400;
  margin: 0 8px;
`;
const CurrentBreadcrumb = styled.span `
  ${fonts.helvetica.regular};
  font-weight: 400;
`;
export const BreadcrumbsStyles = {
    Breadcrumb,
    BreadcrumbLink,
    BreadcrumbList,
    Container,
    CurrentBreadcrumb,
    BreadcrumbDivider,
};
